import { LabelT6 } from "Components/Common/Label/index";
import { Spacer } from "Components/Common/Spacer/index";
import { FlexWrapperT14 } from "Components/Common/Wrapper/FlexWrapper";
import TemperatureCard from "Components/TemperatureCard/index";
import { HANDLING_INSTRUCTIONS } from "Constants/commonConstants";
import React, { Fragment } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import ClassNames from "classnames";

import { ReactComponent as NormalIcon } from "Icons/normal.svg";
import { ReactComponent as TemperatureSensitiveIcon } from "Icons/temp-sensitive.svg";
import { ReactComponent as Sunlight } from "Icons/sunlight.svg";
import { ReactComponent as HygroscopicIcon } from "Icons/hygroscopic.svg";
import { ReactComponent as HandleWithCareIcon } from "Icons/handle-with-care.svg";
import { ReactComponent as VerticalLoadingIcon } from "Icons/vertical-loading.svg";
import { ReactComponent as ImpactSensitiveIcon } from "Icons/impact-sensitive.svg";
import { ReactComponent as ForkLiftIcon } from "Icons/fork-lift.svg";
import { ReactComponent as HydraIcon } from "Icons/hydra.svg";
import { ReactComponent as CraneIcon } from "Icons/crane.svg";

const HandlingInstructions = (props) => {
  const {
    isTemperatureCardShown,
    saveTemperatureDetails,
    cargoInfo = {
      temperatureSensitive: {},
    },
    handlingInstructionTypesList = [],
    handling_instructions = [],
    handleToggleHandlingInstructions,
    handleCloseTemperatureCard,
    temperatureDetails,
    handleSaveTemperatureDetails
  } = props;

  const isSelected = (instructionEle) => {
    const C1 = handling_instructions.some((ele) => {
      if (ele === instructionEle.value) {
        return true;
      } else {
        return false;
      }
    });

    if (C1) {
      return true;
    }

    return false;
  };
  return (
    <Fragment>
      <LabelT6>Handling Instructions</LabelT6>
      <Spacer spacing={"3px"} />
      <FlexWrapperT14>
        {handlingInstructionTypesList.map((instruction, index) => {
          return (
            <div
              className={ClassNames(
                "pr border-white tCenter wt-100 mb-10 ml-10 mr-10 pt-10 pb-10",
                {
                  // 'box-shadow select-icon border-theme br-5': this.cargoInfo.handlingInstructions.indexOf(instruction.value) > -1
                  "box-shadow select-icon border-theme br-5": isSelected(
                    instruction
                  ),
                }
              )}
              key={instruction.value}
              name={instruction.value}
              onClick={() => {
                handleToggleHandlingInstructions(instruction);
              }}
            >
              {instruction.value === 2 && isTemperatureCardShown && (
                <OutsideClickHandler
                  onOutsideClick={handleCloseTemperatureCard}
                >
                  <div className="pa z-1 r-0 l-100p ml-20">
                    <TemperatureCard
                      saveTemperatureDetails={handleSaveTemperatureDetails}
                      minimum={temperatureDetails.temp_min}
                      maximum={temperatureDetails.temp_max}
                      temperatureUnit={temperatureDetails.temp_unit}
                    />
                  </div>
                </OutsideClickHandler>
              )}
              {instruction.value === 1 && <NormalIcon />}
              {instruction.value === 2 && <TemperatureSensitiveIcon />}
              {instruction.value === 3 && <Sunlight />}
              {instruction.value === 4 && <HygroscopicIcon />}
              {instruction.value === 5 && <HandleWithCareIcon />}
              {instruction.value === 6 && <VerticalLoadingIcon />}
              {instruction.value === 7 && <ImpactSensitiveIcon />}
              {instruction.value === 8 && <ForkLiftIcon />}
              {instruction.value === 9 && <HydraIcon />}
              {instruction.value === 10 && <CraneIcon />}
              <div
                className={ClassNames("mt-10 fs-16 fBold tCenter", {
                  // 'theme-color ': this.cargoInfo.handlingInstructions.indexOf(instruction.value) > -1,
                  // 'label-color ': !(this.cargoInfo.handlingInstructions.indexOf(instruction.value) > -1)
                  "theme-color ": isSelected(instruction),
                  "label-color ": !isSelected(instruction),
                })}
              >
                {instruction.name}
              </div>
            </div>
          );
        })}
      </FlexWrapperT14>
    </Fragment>
  );
};

export default HandlingInstructions;
